var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5.5V15.5C22 15.7761 21.7761 16 21.5 16H2.5C2.22386 16 2 15.7761 2 15.5V5.5C2 5.22386 2.22386 5 2.5 5H2.88C3.27769 5.00035 3.65897 5.15862 3.94 5.44L7 8.5L11.28 4.22C11.4205 4.07931 11.6112 4.00018 11.81 4H12.19C12.3888 4.00018 12.5795 4.07931 12.72 4.22L17 8.5L20.06 5.44C20.341 5.15862 20.7223 5.00035 21.12 5H21.5C21.7761 5 22 5.22386 22 5.5ZM22 18.5V19.5C22 19.7761 21.7761 20 21.5 20H2.5C2.22386 20 2 19.7761 2 19.5V18.5C2 18.2239 2.22386 18 2.5 18H21.5C21.7761 18 22 18.2239 22 18.5ZM18 10.33L20 8.33V14H4V8.35L6 10.35C6.10227 10.4456 6.24058 10.493 6.38 10.48H7.66C7.79559 10.482 7.92592 10.4277 8.02 10.33L12.02 6.33L16.02 10.33C16.1141 10.4277 16.2444 10.482 16.38 10.48H17.64C17.7756 10.482 17.9059 10.4277 18 10.33Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.ac85574ce0a28c36955b73c186f72b1b.svg";
export { ForwardRef as ReactComponent };